export default "__VITE_PUBLIC_ASSET__0220578d__"